import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function useCulture() {
	const { t: $t } = useI18n()

	const cultures = computed(() => {
		return {
			'-1':	{
				id: -1,
				title: $t('Not specified'),
				iconKey: 'question-circle',
			},
			'1': {
				id: 1,
				title: $t('Sorghum'),
				iconKey: 'cropsSorghum',
				color: '#D2691E',
			},
			'2': {
				id: 2,
				title: $t('Wheat'),
				iconKey: 'cropsWheat',
				color: '#F2C94C',
			},
			'3': {
				id: 3,
				title: $t('Sugar beet'),
				iconKey: 'cropsSugarBeet',
				color: '#E85D75',
			},
			'4': {
				id: 4,
				title: $t('Corn'),
				iconKey: 'cropsCorn',
				color: '#FFD700',
			},
			'5': {
				id: 5,
				title: $t('Sunflower'),
				iconKey: 'cropsSunflower',
				color: '#FF8C00',
			},
			'6': {
				id: 6,
				title: $t('Soybean'),
				iconKey: 'cropsSoybean',
				color: '#008941',
			},
			'7': {
				id: 7,
				title: $t('Barley'),
				iconKey: 'cropsBarley',
				color: '#C8A86E',
			},
			'8': {
				id: 8,
				title: $t('Peas'),
				iconKey: 'cropsPeas',
				color: '#B5D96A',
			},
			'9': {
				id: 9,
				title: $t('Rape'),
				iconKey: 'cropsRape',
				color: '#BDD400',
			},
			'10': {
				id: 10,
				title: $t('Coriander'),
				iconKey: 'cropsCoriander',
			},
			'11': {
				id: 11,
				title: $t('Alfalfa'),
				iconKey: 'cropsAlfalfa',
				color: '#4DAD8D',
			},
			'12': {
				id: 12,
				title: $t('Vetch'),
				iconKey: 'cropsVetch',
				color: '#A47BD4',
			},
			'13': {
				id: 13,
				title: $t('Oats'),
				iconKey: 'cropsOats',
				color: '#B4C48E',
			},
			'14': {
				id: 14,
				title: $t('Clover'),
				iconKey: 'cropsClover',
			},
			'15': {
				id: 15,
				title: $t('Buckwheat'),
				iconKey: 'cropsBuckwheat',
				color: '#8B4513',
			},
			'16': {
				id: 16,
				title: $t('Millet'),
				iconKey: 'cropsMillet',
				color: '#DAA520',
			},
			'17': {
				id: 17,
				title: $t('Linen'),
				iconKey: 'cropsLinen',
				color: '#6EC6E8',
			},
			'18': {
				id: 18,
				title: $t('Strawberry'),
				iconKey: 'cropsStrawberry',
			},
			'19': {
				id: 19,
				title: $t('Raspberry'),
				iconKey: 'cropsRaspberry',
				color: '#D81B60',
			},
			'20': {
				id: 20,
				title: $t('Currant'),
				iconKey: 'cropsCurrant',
			},
			'21': {
				id: 21,
				title: $t('Blueberry'),
				iconKey: 'cropsBlueberry',
			},
			'22': {
				id: 22,
				title: $t('Cranberry'),
				iconKey: 'cropsCranberry',
			},
			'23': {
				id: 23,
				title: $t('Bilberry'),
				iconKey: 'cropsBilberry',
			},
			'24': {
				id: 24,
				title: $t('Dewberry'),
				iconKey: 'cropsDewberry',
			},
			'25': {
				id: 25,
				title: $t('Rye'),
				iconKey: 'cropsRye',
			},
			'26': {
				id: 26,
				title: $t('Potato'),
				iconKey: 'cropsPotato',
				color: '#C4A35A',
			},
			'27': {
				id: 27,
				title: $t('Chickpea'),
				iconKey: 'cropsChickpea',
				color: '#D4A76A',
			},
			'28': {
				id: 28,
				title: $t('Lentil'),
				iconKey: 'cropsLentil',
				color: '#CB8E5E',
			},
			'29': {
				id: 29,
				title: $t('Garlic'),
				iconKey: 'cropsGarlic',
			},
			'30': {
				id: 30,
				title: $t('Cannabis'),
				iconKey: 'cropsCannabis',
			},
			'31': {
				id: 31,
				title: $t('Mustard'),
				iconKey: 'cropsMustard',
				color: '#E4B430',
			},
			'32': {
				id: 32,
				title: $t('Carrot'),
				iconKey: 'cropsCarrot',
				color: '#ED7D31',
			},
			'33': {
				id: 33,
				title: $t('Nut'),
				iconKey: 'cropsNut',
			},
			'34': {
				id: 34,
				title: $t('Cherry'),
				iconKey: 'cropsCherry',
			},
			'35': {
				id: 35,
				title: $t('Fallow'),
				iconKey: 'cropsFallow',
				color: '#FF90C9',
			},
			'36': {
				id: 36,
				title: $t('Festuca Nutrifiber'),
				iconKey: 'cropsFestucaNutrifiber',
			},
			'37': {
				id: 37,
				title: $t('Agropyron'),
				iconKey: 'cropsAgropyron',
			},
			'38': {
				id: 38,
				title: $t('Cucurbita'),
				iconKey: 'cropsCucurbita',
			},
			'39': {
				id: 39,
				title: $t('Grape'),
				iconKey: 'cropsGrape', // FIXME: add icon
			},
			'40': {
				id: 40,
				title: $t('Bean'),
				iconKey: 'cropsBean',
			},
			'41': {
				id: 41,
				title: $t('Triticale'),
				iconKey: 'cropsTriticale',
			},
			'42': {
				id: 42,
				title: $t('Lupin'),
				iconKey: 'cropsLupin',
			},
			'43': {
				id: 43,
				title: $t('Grain Mixture'),
				iconKey: 'cropsGrainMixture',
				color: '#D4A843',
			},
			'44': {
				id: 44,
				title: $t('Apricot'),
				iconKey: 'cropsApricot',
			},
			'45': {
				id: 45,
				title: $t('Peach'),
				iconKey: 'cropsPeach',
			},
			'46': {
				id: 46,
				title: $t('Quince'),
				iconKey: 'cropsQuince',
			},
			'47': {
				id: 47,
				title: $t('Plum'),
				iconKey: 'cropsPlum',
			},
			'48': {
				id: 48,
				title: $t('Cherries'),
				iconKey: 'cropsCherries',
			},
			'49': {
				id: 49,
				title: $t('Apple'),
				iconKey: 'cropsApple',
				color: '#7CB342',
			},
			'50': {
				id: 50,
				title: $t('Tomato'),
				iconKey: 'cropsTomato',
			},
			'51': {
				id: 51,
				title: $t('Safflower'),
				iconKey: 'cropsSafflower',
				color: '#E57A24',
			},
			'52': {
				id: 52,
				title: $t('Melon'),
				iconKey: 'cropsMelon',
			},
			'53': {
				id: 53,
				title: $t('Watermelon'),
				iconKey: 'cropsWatermelon',
				color: '#2E8B57',
			},
			'54': {
				id: 54,
				title: $t('Cabbage'),
				iconKey: 'cropsCabbage',
				color: '#5CAD5C',
			},
			'55': {
				id: 55,
				title: $t('Field grasses'),
				iconKey: 'cropsFieldGrasses',
				color: '#27AE60',
			},
			'56': {
				id: 56,
				title: $t('Radish'),
				iconKey: 'cropsRadish',
			},
			'57': {
				id: 57,
				title: $t('Durum wheat'),
				iconKey: 'cropsWheat',
				color: '#E8A820',
			},
			'58': {
				id: 58,
				title: $t('Red lentils'),
				iconKey: 'cropsLentil',
				color: '#D44000',
			},
			'59': {
				id: 59,
				title: $t('Annual herbs'),
				iconKey: 'cropsFieldGrasses',
			},
			'60': {
				id: 60,
				title: $t('Red sorghum'),
				iconKey: 'cropsSorghum',
			},
			'61': {
				id: 61,
				title: $t('Khorasan'),
				iconKey: 'cropsWheat',
				color: '#DBD0D2',
			},
			'62': {
				id: 62,
				title: $t('Bromus'),
				iconKey: 'cropsAgropyron',
				color: '#DBD0D2',
			},
			'63': {
				id: 63,
				title: $t('Surepitsa'),
				iconKey: 'cropsVetch',
				color: '#DBD0D2',
			},
			'64': {
				id: 64,
				title: $t('Phacelia'),
				iconKey: 'cropsLinen',
				color: '#DBD0D2',
			},
			'65': {
				id: 65,
				title: $t('Amaranth'),
				iconKey: 'cropsSorghum',
				color: '#845C66',
			},
			'66': {
				id: 66,
				title: $t('Sudan grass'),
				iconKey: 'cropsSorghum',
				color: '#845C66',
			},
			'67': {
				id: 67,
				title: $t('Winter wheat'),
				iconKey: 'cropsWheat',
				color: '#68d162',
			},
			'68': {
				id: 68,
				title: $t('Sweet clover'),
				iconKey: 'cropsAgropyron',
				color: '#c3f263',
			},
			'69': {
				id: 69,
				title: $t('Sainfoin'),
				iconKey: 'cropsAgropyron',
				color: '#4e8cde',
			},
			'70': {
				id: 70,
				title: $t('Bromegrass'),
				iconKey: 'cropsFestucaNutrifiber',
				color: '#ed9c40',
			},
			'71': {
				id: 71,
				title: $t('Couch grass'),
				iconKey: 'cropsAgropyron',
				color: '#f72fb5',
			},
			'72': {
				id: 72,
				title: $t('Spring wheat'),
				iconKey: 'cropsWheat',
				color: '#DEC478',
			},
			'73': {
				id: 73,
				title: $t('Rice'),
				iconKey: 'cropsRice',
				color: '#66CDAA',
			},
			'74': {
				id: 74,
				title: $t('Lentil (general)'),
				iconKey: 'cropsLentil',
				color: '#8B6914',
			},
			'75': {
				id: 75,
				title: $t('Beetroot'),
				iconKey: 'cropsBeetroot',
				color: '#A01050',
			},
			'76': {
				id: 76,
				title: $t('Onion'),
				iconKey: 'cropsOnion',
				color: '#B8860B',
			},
			'77': {
				id: 77,
				title: $t('Table beet'),
				iconKey: 'cropsBeetroot',
				color: '#6B2D5B',
			},
			'78': {
				id: 78,
				title: $t('Winter rye'),
				iconKey: 'cropsRye',
				color: '#7E9B6E',
			},
			'79': {
				id: 79,
				title: $t('Mung bean'),
				iconKey: 'cropsBean',
				color: '#3CB371',
			},
			'80': {
				id: 80,
				title: $t('Corn for silage'),
				iconKey: 'cropsCorn',
				color: '#7BA428',
			},
		}
	})

	return {
		cultures,
		culturesArray: computed(() => Object.values(cultures.value)),
	}
}
